import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isMobile } from 'app/core/helpers/constants';
import {OrdersHistory} from "../../../../core/models/orders-history";
import {BenefitHistoryType} from "../../../../core/helpers/enums";
import {BenefitType} from "../../../../core/helpers/constants";

@Component({
  selector: 'app-benefit-history-details',
  templateUrl: './benefit-history-details.component.html',
  styleUrls: ['./benefit-history-details.component.scss'],
  providers: [TranslatePipe]
})
export class BenefitHistoryDetailsComponent implements OnInit {

  @Input() benefit: OrdersHistory;
  @Input() subdomain: string;
  @Input() hasOrderBeenPlaced: boolean;
  public isMobile = false;

  constructor() { }

  ngOnInit(): void {
    this.isMobile = isMobile();
  }

  isInsuranceBenefit(): boolean {
    return this.benefit?.benefitType === BenefitType.Insurance;
  }

  protected readonly BenefitHistoryType = BenefitHistoryType;
}
